import { useEffect, useState } from "react";
import { DefaultEACard } from "./DefaultEACard";
import {SimpleEACard} from "./SimpleEACard";

export const UserEarnedAccreditations = ({ userID, showYearHeadings, nothingFoundMessage, contentId, layout, count }) => {

  const [ data, setData ] = useState({})
  const [ fetching, setFetching ] = useState(true)

  const Card = 'simple' === layout ? SimpleEACard: DefaultEACard;

  useEffect(() => {
    const ajax = window.Tangible.ajax
    ajax( 'tgbl_cred_user_earned_accreditations_get_course_listing', { user_id: userID, content_id: contentId, count })
      .then( result => {
        // console.log(result)
        if ( Object.keys(result).length ) setData(result)
        setFetching(false)
      })
      .catch( error => {
        console.error(error)
        setFetching(false)
      })
  }, [])

  const cards = []
  let year = ""
  Object.keys(data).reverse().forEach( earnDatetime => {
    if ( showYearHeadings ) {
      const currentYear = new Date( earnDatetime * 1000 ).getFullYear()
      if ( year !== currentYear ) {
        year = currentYear
        cards.push(<div key={year} className="tgbl-user-earned-accreditations__list__section-heading">
          <h2 className="tgbl-user-earned-accreditations__list__section-heading__text">{year}</h2>
        </div>)
      }
    }

    Object.keys(data[earnDatetime]).forEach( courseID => {
      cards.push(<Card
        key={`${earnDatetime}-${courseID}`}
        data={{ course_id: courseID, content_id: contentId, earn_date: earnDatetime, ...data[earnDatetime][courseID] }}
      />)
    })
  })

  return (
    <div className="tgbl-interface tgbl-user-earned-accreditations">
      <div className="tgbl-user-earned-accreditations__list tgbl-grid">
        { fetching
          ? 'Loading...'
          : ( cards.length > 0 ? cards : nothingFoundMessage )
        }
      </div>
    </div>
  )
}
